import React from "react";
import OptionsList from "../OptionsList/OptionsList";
import KYCQuestion from "./KYCQuestion";

export default class OriginOfCompanyFunds extends KYCQuestion
{
    state = {
        fields: {
            aml_origin_options: {
                options: [
                    {
                        name: "checkbox_company_funds_profit",
                        label: "Vinst från den egna verksamheten",
                        value: "Ja",
                        checked: false
                    },
                    {
                        name: "checkbox_company_funds_compsales",
                        label: "Företagsförsäljning",
                        value: "Ja",
                        checked: false
                    },
                    {
                        name: "checkbox_company_funds_aktiekapital",
                        label: "Aktiekapital",
                        value: "Ja",
                        checked: false
                    },
                    {
                        name: "checkbox_company_funds_invest",
                        label: "Tidigare placeringar/investeringar",
                        value: "Ja",
                        checked: false
                    },
                    {
                        name: "checkbox_company_funds_membership",
                        label: "Medlemsavgifter",
                        value: "Ja",
                        checked: false
                    },
                    {
                        name: "checkbox_company_funds_donation",
                        label: "Donationer",
                        value: "Ja",
                        checked: false
                    },
                    {
                        name: "checkbox_company_funds_grants",
                        label: "Anslag",
                        value: "Ja",
                        checked: false
                    }
                ]
            }
        }
    };

    constructor(props, context)
    {
        super(props, context);
        this.fieldName = "aml_origin_options";
    }

    render()
    {
        return (
            <React.Fragment>
                <OptionsList
                    style={{marginTop: "35px"}}
                    type="checkbox"
                    name="aml_origin_options"
                    description="Var kommer företagets pengar och/eller värdepapper ifrån?"
                    orientation="vertical"
                    onChange={this._onOptionsListChange}
                    options={this.state.fields.aml_origin_options.options}
                />
            </React.Fragment>
        );
    }
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/KYC/OriginOfCompanyFunds.js